export const CLIENT_ERROR_LOG_TEXT = 'A user has encountered an error page on the client';
export const CLIENT_ERROR_VISIBLE_MESSAGE =
  'Sorry, this page encountered a problem. We automatically track issues like this, please try again';

type ExpandedError = {
  error: string;
  stack?: string;
  cause?: ExpandedError;
  [key: string]: unknown;
};

/**
 * Error properties are non-enumerable, so we need to expand them manually to ensure
 * Winston doesn't ignore them (when attaching an error to a log as metadata).
 */
export const expandError = (err: unknown): ExpandedError | { error: unknown } => {
  if (err instanceof Error) {
    const { cause, message, stack, ...rest } = Object.getOwnPropertyDescriptors(err);

    return {
      error: message.value,
      stack: stack?.value,
      ...(cause?.value ? { cause: expandError(cause.value) } : {}),
      ...Object.fromEntries(Object.entries(rest).map(([key, descriptor]) => [key, descriptor.value])),
    };
  }

  return { error: err };
};
